export default {
  label: 'By submitting your information, you confirm you have read the [LINK]',
  text: 'Privacy Policy',
  url: 'https://policies.edusites.net/privacyus'
}